import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import BaseScreen from "./pages/BaseScreen/BaseScreen";
import HomeScreen from "./pages/HomeScreen/HomeScreen";
import ContactScreen from "./pages/ContactScreen/ContactScreen";
import Prestations from "./pages/Prestations/Prestations";
import Informations from "./pages/Informations/Informations";
import Apropos from "./pages/A_propos/Apropos";
import LadyStyle from "./pages/LadyStyle/LadyStyle";
import './output.css';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BaseScreen />}>
            <Route index element={<HomeScreen />} />
            <Route path="a_propos" element={<Apropos />} />
            <Route path="contact" element={<ContactScreen />} />
            <Route path="Prestations" element={<Prestations />} />
            <Route path="lady_style" element={<LadyStyle />} />
            <Route path="informations" element={<Informations />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
